import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
// sections
import { CategoryListHomeView } from 'src/sections/blog/view';

// ----------------------------------------------------------------------

export default function CategoryListHomePage() {
  const { isRTL } = useLocales();
  return (
    <>
      <Helmet>
        <title> Category: List</title>
      </Helmet>

      <CategoryListHomeView isRTL={isRTL} />
    </>
  );
}
